<button class="yomi-menu__modify" (click)="toggleGlobalGyosekiManagementHeader()">
  <span *ngIf="!isHeaderOpen">
    業績管理表を開く
  </span>
  <span *ngIf="isHeaderOpen">
    業績管理表を閉じる（更新）
  </span>
  <span
    class="yomi-menu__modify__arrow"
    [class.yomi-menu__modify__arrow--down]="!isHeaderOpen"
    [class.yomi-menu__modify__arrow--up]="isHeaderOpen"
  ></span>
</button>

<div
  class="yomic"
  *ngIf="isHeaderOpen"
>
  <div *ngIf="userHasManagementRole" class="yomi-header">
    <ng-container *ngIf="userHasManagementRole">
      <div
        *ngFor="let team of authService.loginUser?.managementTeams"
        class="yomi-header__item btn"
        [ngClass]="{
          'btn--blue': selectedManagementTeamId === team.id,
          'link blue': selectedManagementTeamId !== team.id
        }"
        (click)="updateTableDataWithTeamId(team.id)"
      >
        {{ team.name }}
      </div>
      <div
        *ngIf="userHasManagementRole"
        class="yomi-header__item btn"
        [ngClass]="{
          'btn--blue': !selectedManagementTeamId,
          'link blue': selectedManagementTeamId
        }"
        (click)="updateTableDataWithTeamId(null)"
      >
        個人
      </div>
    </ng-container>
  </div>

  <div class="yomi-subfilter">
    <div class="yomi-subfilter-inner">
      <div class="date-filter">
        <input
          type="month"
          (change)="handleUpdateFilter()"
          [(ngModel)]="selectedExpectedContractMonthValue" />
        <!-- [min]="expectedContractMonthMinOption"
          [max]="expectedContractMonthMaxOption" -->
      </div>

      <div *ngIf="!selectedManagementTeamId" class="goal-filter">
        <span>SN目標</span>
        <input
          type="number"
          [(ngModel)]="salesSummaryForUserModel.ca.snTarget">
        <button
          class="update-filter btn btn--blue btn--small"
          (click)="handleSaveMyMonthlySalesOverviewForTargetMonth()"
        >
          更新
        </button>
      </div>
      <div *ngIf="selectedManagementTeamId" class="goal-filter">
        <span>SN目標</span>
        <input
          disabled
          type="number"
          [(ngModel)]="salesSummaryForTeamModel.ca.total.snTarget">
      </div>

      <div *ngIf="!selectedManagementTeamId" class="goal-filter">
        <span>GK目標</span>
        <input
          type="number"
          [(ngModel)]="salesSummaryForUserModel.ca.gkTarget">
        <button
          class="update-filter btn btn--blue btn--small"
          (click)="handleSaveMyMonthlySalesOverviewForTargetMonth()"
        >
          更新
        </button>
      </div>
      <div *ngIf="selectedManagementTeamId" class="goal-filter">
        <span>GK目標</span>
        <input
          disabled
          type="number"
          [(ngModel)]="salesSummaryForTeamModel.ca.total.gkTarget">
      </div>

      <div *ngIf="!selectedManagementTeamId" class="goal-filter">
        <span>Mach外売上</span>
        <input
          type="number"
          [(ngModel)]="salesSummaryForUserModel.ca.externalSalesRevenue">
        <button
          class="update-filter btn btn--blue btn--small"
          (click)="handleSaveMyMonthlySalesOverviewForTargetMonth()"
        >
          更新
        </button>
      </div>
      <div *ngIf="selectedManagementTeamId" class="goal-filter">
        <span>Mach外売上</span>
        <input
          disabled
          type="number"
          [(ngModel)]="salesSummaryForTeamModel.ca.total.externalSalesRevenue">
      </div>

      <div *ngIf="!selectedManagementTeamId" class="goal-filter">
        <span>GK:</span>
        <ng-content
          *ngTemplateOutlet="
            numDisplaySpan;
            context: {
              value: salesSummaryForUserModel.ca.gkActual
            }
          "
        >
        </ng-content>
      </div>
      <div *ngIf="selectedManagementTeamId" class="goal-filter">
        <span>GK:</span>
        <ng-content
          *ngTemplateOutlet="
            numDisplaySpan;
            context: { value: salesSummaryForTeamModel?.ca?.total?.gkActual }
          "
        >
        </ng-content>
      </div>

      <div *ngIf="!selectedManagementTeamId" class="goal-filter">
        <span>GK達成率:</span>
        <ng-content
          *ngTemplateOutlet="
            numDisplaySpan;
            context: {
              value: salesSummaryForUserModel.ca.gkActualAchievementRate,
              unitLabel: '%'
            }
          "
        >
        </ng-content>
      </div>
      <div *ngIf="selectedManagementTeamId" class="goal-filter">
        <span>GK達成率:</span>
        <ng-content
          *ngTemplateOutlet="
            numDisplaySpan;
            context: {
              value: salesSummaryForTeamModel?.ca?.total?.gkActualAchievementRate,
              unitLabel: '%'
            }
          "
        >
        </ng-content>
      </div>
      <!-- 週目標 -->
      <!-- <div class="weekly-filter">
        <span>週目標</span>
        <input
          type="text"
          disabled
          [(ngModel)]="expectedContractWeeklyValue">
      </div> -->

    </div>
  </div>
  
  <!-- 業績管理表 - 担当別月間売上 -->
  <ag-gyoseki-management-sales-amount-table
    [selectedManagementTeamId]="selectedManagementTeamId"
    [salesForUserModel]="salesForUserModel"
    [salesForTeamModel]="salesForTeamModel"
    [salesSummaryForTeamModel]="salesSummaryForTeamModel"
    [salesSummaryForUserModel]="salesSummaryForUserModel"
  ></ag-gyoseki-management-sales-amount-table>

  <ag-customer-filter-button-and-dialog
    [filterDefinitions]="customerFilterDefinitions"
    [currentConditions]="customerFilterConditions"
    (filtersChange)="handleCustomerFilterChange($event)"
  ></ag-customer-filter-button-and-dialog>

  <!-- ページネーション -->
  <div class="yomic-pagination">
    <div class="yomic-pagination__range">全{{totalFilteredCount}}件中 {{pageRangeStart}}件〜{{pageRangeEnd}}件を表示</div>
    <button
      class="yomic-pagination__btn"
      [disabled]="currentPage === 1"
      (click)="goToPage(currentPage - 1)"
    >&lt; 前へ</button>
    <ng-container *ngFor="let p of pageNumbers">
      <span *ngIf="p === '...'" class="yomic-pagination__ellipsis">...</span>
      <button
        *ngIf="p !== '...'"
        class="yomic-pagination__btn"
        [class.yomic-pagination__btn--active]="p === currentPage"
        (click)="goToPage(+p)"
      >{{ p }}</button>
    </ng-container>
    <button
      class="yomic-pagination__btn"
      [disabled]="currentPage === totalPages || totalPages === 0"
      (click)="goToPage(currentPage + 1)"
    >次へ &gt;</button>
  </div>

  <ng-content
    *ngTemplateOutlet="
      table_template;
      context: { collection: displayedCustomers, total: displayedCustomers.length }
    "
  >
  </ng-content>
</div>

<ng-template
  #numDisplaySpan
  let-value="value"
  let-unitLabel="unitLabel"
>
  <span *ngIf="!value && value !== 0"> -  {{unitLabel}}</span>
  <span *ngIf="value || value === 0">{{(value | undef | number: '0.0-2')}} {{unitLabel}}</span>
</ng-template>

<ng-template #headerTemplate>
  <thead>
    <tr>
      <th *ngIf="selectedManagementTeamId" class="yomic_table__th yomic_table__th__username">
        ユーザー名
        <span
          *ngIf="userNameSortStatus === 'asc'"
          (click)="handlerUserNameSort()"
        >
          <img class="yomic_table__th__active__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="userNameSortStatus === 'desc'"
          (click)="handlerUserNameSort()"
        >
          <img class="yomic_table__th__active__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="yomic_table__th yomic_table__th__komi">
        ヨミ
        <span
          *ngIf="yomiSortStatus === 'asc'"
          (click)="handlerYomiSort()"
        >
          <img class="yomic_table__th__active__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="yomiSortStatus === 'desc'"
          (click)="handlerYomiSort()"
        >
          <img class="yomic_table__th__active__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="yomic_table__th yomic_table__th__active">
        稼働
        <span
          *ngIf="activeSortStatus === 'asc'"
          (click)="handlerActiveSort()"
        >
          <img class="yomic_table__th__active__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="activeSortStatus === 'desc'"
          (click)="handlerActiveSort()"
        >
          <img class="yomic_table__th__active__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="yomic_table__th yomic_table__th__progress">
        進捗
        <span
          *ngIf="progressSortStatus === 'asc'"
          (click)="handlerProgressSort()"
        >
          <img class="yomic_table__th__progress__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="progressSortStatus === 'desc'"
          (click)="handlerProgressSort()"
        >
          <img class="yomic_table__th__progress__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="yomic_table__th yomic_table__th__customer">
        求職者
        <span
          *ngIf="graduateYearSortStatus === 'asc'"
          (click)="handlerGraduateYearSort()"
        >
          <img class="yomic_table__th__customer__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="graduateYearSortStatus === 'desc'"
          (click)="handlerGraduateYearSort()"
        >
          <img class="yomic_table__th__customer__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="yomic_table__th yomic_table__th__actions">&#8195;&#8195;</th>
      <th class="yomic_table__th yomic_table__th__sf">
        SF
        <span
          *ngIf="sfSortStatus === 'asc'"
          (click)="handlerSfSort()"
        >
          <img class="yomic_table__th__sf__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="sfSortStatus === 'desc'"
          (click)="handlerSfSort()"
        >
          <img class="yomic_table__th__sf__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
      <th class="yomic_table__th yomic_table__th__enterprise">ご支援想定企業</th>
      <th class="yomic_table__th yomic_table__th__enterprise">ご支援想定企業2</th>
      <th class="yomic_table__th yomic_table__th__memo-now">SK</th>
      <th class="yomic_table__th yomic_table__th__yomi3">
        <div class="th-yomi3-upper-area">3軸のヨミ情報</div>
        <div class="th-yomi3-lower-area">
          <span
            *ngIf="yomi3PassedSortStatus === 'asc'"
            (click)="handlerYomi3Sort(Yomi3Target.passed)"
          >
            合格<img class="yomic_table__th__sf__img" src="/assets/icons/arrow-up.png" />
          </span>
          <span
            *ngIf="yomi3PassedSortStatus === 'desc'"
            (click)="handlerYomi3Sort(Yomi3Target.passed)"
          >
            合格<img class="yomic_table__th__sf__img" src="/assets/icons/arrow-down.png" />
          </span>
          <span
            *ngIf="yomi3InclinationSortStatus === 'asc'"
            (click)="handlerYomi3Sort(Yomi3Target.inclination)"
          >
            意向<img class="yomic_table__th__sf__img" src="/assets/icons/arrow-up.png" />
          </span>
          <span
            *ngIf="yomi3InclinationSortStatus === 'desc'"
            (click)="handlerYomi3Sort(Yomi3Target.inclination)"
          >
            意向<img class="yomic_table__th__sf__img" src="/assets/icons/arrow-down.png" />
          </span>
          <span
            *ngIf="yomi3ScheduleSortStatus === 'asc'"
            (click)="handlerYomi3Sort(Yomi3Target.schedule)"
          >
            日程<img class="yomic_table__th__sf__img" src="/assets/icons/arrow-up.png" />
          </span>
          <span
            *ngIf="yomi3ScheduleSortStatus === 'desc'"
            (click)="handlerYomi3Sort(Yomi3Target.schedule)"
          >
            日程<img class="yomic_table__th__sf__img" src="/assets/icons/arrow-down.png" />
          </span>
        </div>
      </th>
      <th class="yomic_table__th yomic_table__th__memo-now">メモ</th>
      <th class="yomic_table__th yomic_table__th__memo-wish">志望順位</th>
      <th class="yomic_table__th yomic_table__th__memo-next">ネクストアクション</th>
      <th class="yomic_table__th yomic_table__th__ra-yomi">RAヨミ</th>
      <th class="yomic_table__th yomic_table__th__last-contact">
        コンタクト
        <span
          *ngIf="pickUpMemoRegisterSortStatus === 'asc'"
          (click)="handlerPickUpMemoRegisterSort()"
        >
          <img class="yomic_table__th__second-match__img" src="/assets/icons/arrow-up.png" />
        </span>
        <span
          *ngIf="pickUpMemoRegisterSortStatus === 'desc'"
          (click)="handlerPickUpMemoRegisterSort()"
        >
          <img class="yomic_table__th__second-match__img" src="/assets/icons/arrow-down.png" />
        </span>
      </th>
    </tr>
  </thead>
</ng-template>

<ng-template
  #table_template
  let-collection="collection"
  let-total="total"
>
  <table class="yomic_table" *ngIf="total && !loadingCustomer">
    <ng-content *ngTemplateOutlet="headerTemplate"></ng-content>
    <tbody>
      <tr
        *ngFor="let data of collection"
      >
        <td *ngIf="selectedManagementTeamId && userTeamInjector.getUserTeamInfoById(data.studentUser[0].userId) | async as user" class="yomic_table__td">
          <div class="td-wrap">
            <span class="yomic_table__td_active__data">
              {{user.name}}
            </span>
          </div>
        </td>
        <td class="yomic_table__td">
          <div class="td-wrap">
            <!-- This should be dynamic (?) and update based on records... -->
            <!-- Also research into what is a normal select dropdown in this project E.g. <ag-select> -->
            <select
              class="select select--bg-gray select--small"
              [(ngModel)]="data.dynamicData.yomi"
              (change)="handlerYomiTypeChange(data.id)"
              >
              <option
                  *ngFor="let dd of yomiDropdownData"
                  [ngValue]="dd.value"
                  >{{ dd.label }}</option
                >
            </select>
          </div>
        </td>
        <td class="yomic_table__td">
          <div class="yomic_table__td_active">
            <span class="yomic_table__td_active__data">
              {{ data.activeCount }}
            </span>
          </div>
        </td>
        <td class="yomic_table__td">
          <div class="yomic_table__td_progress">
            <span class="yomic_table__td_progress__data">
              {{ data.progressCount }}
            </span>
          </div>
        </td>
        <td class="yomic_table__td">
          <div class="yomic_table__td_customer">
            <div class="yomic_table__td_customer__above">
              <span class="yomic_table__td_customer__above__frontid">
                {{data?.frontId}}
              </span>
              <span
                *ngIf="data?.dynamicData?.academicFieldType"
                class="yomic_table__td_customer__above__flag"
                [class.yomic_table__td_customer__above__flag--pink]="
                  data?.dynamicData?.academicFieldType?.includes('文')
                "
                [class.yomic_table__td_customer__above__flag--blue]="
                  data?.dynamicData?.academicFieldType?.includes('理')
                "
                >{{
                  data?.dynamicData.academicFieldType.includes("文") ? "文" : "理"
                }}</span
              >
              <span
                *ngIf="data?.dynamicData?.academicHistory1?.graduateYear"
                class="yomic_table__td_customer__above__flagg yomic_table__td_customer__above__flagg--blue"
              >
                {{handlerGraduateYearView(data.dynamicData.academicHistory1.graduateYear) }} 卒
              </span>
              <span class="yomic_table__td_customer__above__rank">
                |&nbsp;{{data?.dynamicData.universityLevel | slice: 0 : 1}}&nbsp;|
              </span>
            </div>
            <div
              class="yomic_table__td_customer__under"
              (click)="onItemSelect(data)"
            >
              {{data?.fullName}}
            </div>
          </div>
        </td>
        <td class="yomic_table__td">
          <div class="yomic_table__td_actions">
            <div class="yomic_table__td_actions__above">
              <a
                class="yomic_table__td_actions__chat"
                (click)="onItemSelect(data)"
              >
                <div class="yomic_table__td_actions__icon">
                  <img class="yomic_table__td_actions__img" src="/assets/images/phone.png" />
                </div>
              </a>
              <a
                class="yomic_table__td_actions__chat"
                (click)="
                  true
                    ? openChat(data?.dynamicData?.lineId)
                    : ''
                "
              >
                <div class="yomic_table__td_actions__icon">
                  <img class="yomic_table__td_actions__img" src="/assets/images/chat.png" />
                </div>
              </a>
            </div>
            <div class="yomic_table__td_actions__under">
              <a
                class="yomic_table__td_actions__chat"
                (click)="
                  data.dynamicData?.emailMain?.email &&
                  !data.dynamicData?.emailMain?.emailAvailable
                    ? openMailSend(sendConfig, data)
                    : ''
                "
              >
                <div class="yomic_table__td_actions__icon">
                  <img class="yomic_table__td_actions__img" src="/assets/images/mail.png" />
                </div>
              </a>
              <a
                class="yomic_table__td_actions__chat"
                (click)="onItemSelectAndMemo(data)"
              >
                <div class="yomic_table__td_actions__icon">
                  <img class="yomic_table__td_actions__img" src="/assets/images/note.png" />
                </div>
              </a>
            </div>
          </div>
        </td>
        <td class="yomic_table__td">
          <div class="yomic_table__td_sf">
            <span
              *ngIf="data?.dynamicData?.rank"
              class="yomic_table__td_sf--flag yomic_table__td_sf--flag--{{ data.dynamicData.rank }}"
            >{{data.dynamicData.rank}}</span>
          </div>
        </td>
        <td class="yomic_table__td">
          <div class="yomic_table__td_enterprise">
            <div class="yomic_table__td_enterprise__above">
              <select
                class="yomic_table__td_enterprise__above__select select select--bg-gray select--small"
                [(ngModel)]="customersExpectedCompanyProgressIdMapping[data.id]"
                (change)="handleChangeExpectedCompany(data.id, customersExpectedCompanyProgressIdMapping[data.id])"
              >
                <option
                  *ngFor="let expectedCompany of customersExpectedCompanyUIList[data.id]"
                  [value]="expectedCompany.value"
                  >{{ expectedCompany.label }}</option
                >
              </select>
            </div>
            <div class="yomic_table__td_enterprise__under">
              <span
                *ngIf="customersExpectedCompanyMapping[data.id]"
                class="yomic_table__td_enterprise__under__flagg"
                [class.yomic_table__td_enterprise__under__flagg--ag]="customersExpectedCompanyMapping[data.id].p_type === 0"
                [class.yomic_table__td_enterprise__under__flagg--plus]="customersExpectedCompanyMapping[data.id].p_type === 1"
              >{{handlerExpectedCompanyTypeView(customersExpectedCompanyMapping[data.id].p_type)}}</span>

              <span *ngIf="customersExpectedCompanyMapping[data.id]" class="yomic_table__td_enterprise__under__user">
                {{ customersExpectedCompanyMapping[data.id].ra_u_name | truncate: 5 }}
              </span>
              <span *ngIf="customersExpectedCompanyMapping[data.id]" class="yomic_table__td_enterprise__under__status">
                {{ handlerProgressStatusView(customersExpectedCompanyMapping[data.id]) | truncate: 6 }}
              </span>
              <span *ngIf="customersExpectedCompanyMapping[data.id] && customersExpectedCompanyMapping[data.id].p_seminar_at" class="yomic_table__td_enterprise__under__date">
                {{ customersExpectedCompanyMapping[data.id].p_seminar_at | date: "yyyy/MM/dd" }}
              </span>
            </div>
          </div>
        </td>
        <!-- ご支援想定企業 2 -->
        <td class="yomic_table__td">
          <div class="yomic_table__td_enterprise">
            <div class="yomic_table__td_enterprise__above">
              <select
                class="yomic_table__td_enterprise__above__select select select--bg-gray select--small"
                [(ngModel)]="customersExpectedCompany2ProgressIdMapping[data.id]"
                (change)="handleChangeExpectedCompany2(data.id, customersExpectedCompany2ProgressIdMapping[data.id])"
              >
                <option
                  *ngFor="let expectedCompany of customersExpectedCompanyUIList[data.id]"
                  [value]="expectedCompany.value"
                  >{{ expectedCompany.label }}</option
                >
              </select>
            </div>
            <div class="yomic_table__td_enterprise__under">
              <span
                *ngIf="customersExpectedCompany2Mapping[data.id]"
                class="yomic_table__td_enterprise__under__flagg"
                [class.yomic_table__td_enterprise__under__flagg--ag]="customersExpectedCompany2Mapping[data.id].p_type === 0"
                [class.yomic_table__td_enterprise__under__flagg--plus]="customersExpectedCompany2Mapping[data.id].p_type === 1"
              >{{handlerExpectedCompanyTypeView(customersExpectedCompany2Mapping[data.id].p_type)}}</span>

              <span *ngIf="customersExpectedCompany2Mapping[data.id]" class="yomic_table__td_enterprise__under__user">
                {{ customersExpectedCompany2Mapping[data.id].ra_u_name | truncate: 5 }}
              </span>
              <span *ngIf="customersExpectedCompany2Mapping[data.id]" class="yomic_table__td_enterprise__under__status">
                {{ handlerProgressStatusView(customersExpectedCompany2Mapping[data.id]) | truncate: 6 }}
              </span>
              <span *ngIf="customersExpectedCompany2Mapping[data.id] && customersExpectedCompany2Mapping[data.id].p_seminar_at" class="yomic_table__td_enterprise__under__date">
                {{ customersExpectedCompany2Mapping[data.id].p_seminar_at | date: "yyyy/MM/dd" }}
              </span>
            </div>
          </div>
        </td>
        <!-- SK -->
        <td class="yomic_table__td">
          <div class="yomic_table__td__sk">
            <div class="yomic_table__td__sk-input-area">
              <input
                type="number"
                [disabled]="!customersExpectedCompanyProgressIdMapping[data.id]"
                [(ngModel)]= "customersExpectedCompanyMapping[data.id].p_ca_expected_sk"
              />
              <button
                [disabled]="!customersExpectedCompanyProgressIdMapping[data.id]"
                class="update-filter btn btn--blue btn--minimum"
                (click)="handleShowCaExpectedSKInfoDialog(data.id)"
              ></button>
            </div>
            <button
              [disabled]="!customersExpectedCompanyProgressIdMapping[data.id]"
              class="update-filter btn btn--blue btn--small"
              (click)="handleCaExpectedSKUpdate(data.id, customersExpectedCompanyMapping[data.id].p_ca_expected_sk)"
            >更新</button>
          </div>
        </td>
        <!-- ヨミ3軸 -->
        <td class="yomic_table__td">
          <div class="td-wrap">
            <div class="yomic_table__td__ca3yomis">
              <div class="yomic_table__td__ca3yomi-upper-area">
                <select
                  class="select select--bg-gray select--small"
                  [disabled]="!customersExpectedCompanyProgressIdMapping[data.id]"
                  [(ngModel)]="customersExpectedCompanyMapping[data.id].p_yomi_3_passed"
                  (ngModelChange)="handleYomi3Change(data.id, Yomi3Target.passed)"
                >
                  <option
                      *ngFor="let dd of yomi3PassedDropdownData"
                      [ngValue]="dd.value"
                      >{{ dd.label }}</option
                    >
                </select>
                <select
                  class="select select--bg-gray select--small"
                  [disabled]="!customersExpectedCompanyProgressIdMapping[data.id]"
                  [(ngModel)]="customersExpectedCompanyMapping[data.id].p_yomi_3_inclination"
                  (ngModelChange)="handleYomi3Change(data.id, Yomi3Target.inclination)"
                >
                  <option
                      *ngFor="let dd of yomi3InclinationDropdownData"
                      [ngValue]="dd.value"
                      >{{ dd.label }}</option
                    >
                </select>
                <select
                  class="select select--bg-gray select--small"
                  [disabled]="!customersExpectedCompanyProgressIdMapping[data.id]"
                  [(ngModel)]="customersExpectedCompanyMapping[data.id].p_yomi_3_schedule"
                  (ngModelChange)="handleYomi3Change(data.id, Yomi3Target.schedule)"
                >
                  <option
                      *ngFor="let dd of yomi3ScheduleDropdownData"
                      [ngValue]="dd.value"
                      >{{ dd.label }}</option
                    >
                </select>
              </div>
              <div class="yomic_table__td__ca3yomi-lower-area">
                <div class="yomi3-probability-calc-result">
                  <div
                    class="yomi3-probability-calc-result--label"
                    [ngClass]="{
                      'max': customersExpectedCompanyMapping[data.id].yomi3ProbabilityCalcResult?.label === 'MAX',
                      'mid': customersExpectedCompanyMapping[data.id].yomi3ProbabilityCalcResult?.label === 'MID',
                      'min': customersExpectedCompanyMapping[data.id].yomi3ProbabilityCalcResult?.label === 'MIN'
                    }"
                    *ngIf="customersExpectedCompanyMapping[data.id].yomi3ProbabilityCalcResult?.label"
                  >
                    {{customersExpectedCompanyMapping[data.id].yomi3ProbabilityCalcResult?.label}}
                  </div>
                  <div
                    class="yomi3-probability-calc-result--probability"
                  >
                    {{(customersExpectedCompanyMapping[data.id].yomi3ProbabilityCalcResult?.probability | number:'1.1-2') || '------'}}
                  </div>
                </div>
                <input
                  type="month"
                  (change)="handleUpdateExpectedContractMonth($event, data)"
                  [value]="getYearMonthFromDateString(data.dynamicData.expectedContractMonth)" />
                <select
                  class="select select--bg-gray select--small"
                  [(ngModel)]="data.dynamicData.expectedContractWeek"
                  (change)="handleUpdateExpectedContractWeek(data)"
                  >
                  <option
                      *ngFor="let dd of expectedContractWeekDropdownData"
                      [ngValue]="dd.value"
                      >{{ dd.label }}</option
                    >
                </select>
              </div>
            </div>
          </div>
        </td>
        <!-- メモ -->
        <td class="yomic_table__td">
          <div class="yomic_table__td_memos">
            <textarea
              class="yomic_table__td_memos__text"
              [(ngModel)]= "pickUpMemo[data.id].situationMemoData.memo"
            ></textarea>
          </div>
        </td>
        <td class="yomic_table__td">
          <div class="yomic_table__td_memos">
            <textarea
              class="yomic_table__td_memos__text"
              [(ngModel)]= "pickUpMemo[data.id].situationMemoData.orderOfPreference"
            ></textarea>

            <button
              class="update-filter btn btn--blue btn--small"
              (click)="handleSaveMemo(data.id, pickUpMemo[data.id])"
            >更新</button>
          </div>
        </td>
        <td class="yomic_table__td">
          <div class="yomic_table__td_memos">
            <textarea
              class="yomic_table__td_memos__text"
              [(ngModel)]= "pickUpMemo[data.id].situationMemoData.nextAction"
            ></textarea>
          </div>
        </td>
        <!-- RAヨミ -->
        <td class="yomic_table__td">
          <div class="td-wrap">
            <div class="yomic_table__td_ra-yomi">
              <div
                *ngFor="let raYomiProgress of customerRaYomiProgressMapping[data.id]"
                class="yomic_table__td_ra-yomi__item"
              >
                <div class="yomic_table__td_ra-yomi__item__top">
                  <span class="yomic_table__td_ra-yomi__item__ra-user">
                    {{ raYomiProgress.raUserName }}
                  </span>
                  <span class="yomic_table__td_ra-yomi__item__yomi">
                    {{ raYomiProgress.raYomi }}
                  </span>
                  <span class="yomic_table__td_ra-yomi__item__enterprise">
                    {{ raYomiProgress.enterpriseName }}
                  </span>
                  <span class="yomic_table__td_ra-yomi__item__month">
                    {{ raYomiProgress.targetMonth }}
                  </span>
                </div>
                <div class="yomic_table__td_ra-yomi__item__bottom">
                  <span class="yomic_table__td_ra-yomi__item__yomi3">
                    {{ raYomiProgress.yomi3Text }}
                  </span>
                  <div
                    *ngIf="raYomiProgress.probabilityLabel"
                    class="yomi3-probability-calc-result"
                  >
                    <div
                      class="yomi3-probability-calc-result--label"
                      [ngClass]="{
                        'max': raYomiProgress.probabilityLabel === 'MAX',
                        'mid': raYomiProgress.probabilityLabel === 'MID',
                        'min': raYomiProgress.probabilityLabel === 'MIN'
                      }"
                    >
                      {{ raYomiProgress.probabilityLabel }}
                    </div>
                    <div class="yomi3-probability-calc-result--probability">
                      {{ raYomiProgress.probability | number:'1.1-2' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
        <td class="yomic_table__td">
          <div class="yomic_table__td_date__above">
            <span
              class="yomic_table__td_date"
            >
              {{toJstDateStr(pickUpMemo[data.id].registerDate) | slice: 0 : 4}}
            </span>
          </div>
          <div class="yomic_table__td_date__under">
            <span
              class="yomic_table__td_date"
            >
              {{pickUpMemo[data.id].registerDate && handlerDateMonthDayPlusjp(toJstDateStr(pickUpMemo[data.id].registerDate))}}
            </span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</ng-template>
